import React from "react";
import { Helmet } from "react-helmet-async";
import UtilitiesLandingPage from "./UtilitiesLandingPage";

function UtilitiesDashbord() {
  return (
    <>
      <Helmet>
        <title>Utilities Dashboard</title>
      </Helmet>
      <UtilitiesLandingPage />
    </>
  );
}

export default UtilitiesDashbord;
